// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".checkbox[data-v-04a5a020]{font-size:14px}.spinner[data-v-04a5a020]{-ms-flex-item-align:center;align-self:center}.status-icon[data-v-04a5a020]{--icon-color:var(--status-color,#505050)}form[data-v-04a5a020]{--icon-color:#505050}.link[data-v-04a5a020]{color:var(--color-primary);font-weight:500}.btn.close[data-v-04a5a020]{min-width:200px;-ms-flex-item-align:center;align-self:center;margin-top:24px;-ms-flex-negative:0;flex-shrink:0}", ""]);
// Exports
module.exports = exports;
